import { MoneyCollectOutlined, PoweroffOutlined } from '@ant-design/icons';
import { Col, Result, Row, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import Modal from '@/components/Modal';
import OrderDescriptions from '@/components/OrderDescriptions';
import PosButton from '@/components/PosButton';
import { setConsumerDisplayImage } from '@/models/consumerDisplay';
import { POSPaymentResponse } from '@/models/pos';
import { noop } from '@/utils/common';
import { Custom_Display_Type_ENUM } from '@/utils/uiHelper';
import styles from './paymentSuccess.less';
import UserGuide from './UserGuide';
import { User } from '@/models/user';
import { Order } from '@/models/order';

type Props = POSPaymentResponse & {
  onClose: () => void;
  /**类型， 支付完成还是服务完成 */
  type: 'pay' | 'service';
  onDataChange: (user?: User, order?: Order) => void;
};
const PaymentSuccess: React.FC<Props> = ({
  order,
  user,
  skuList,
  transactionList,
  type,
  onClose = () => {},
  onDataChange,
}: Props) => {
  const [open, setOpen] = useState(false);
  const title = type === 'pay' ? '收款成功' : '服务完成';
  useHotkeys(
    'enter',
    () => {
      setOpen(false);
    },
    [setOpen]
  );

  useEffect(() => {
    setOpen(!!order);
    if (order) {
      // 交易成功，显示微信名片
      setConsumerDisplayImage(Custom_Display_Type_ENUM.CARD);
    }
  }, [order]);

  // useEffect(() => {
  //   const id1 = addWsListener<{ username: string; displayName: string }>(
  //     DOMAIN_INTERACT_OUTSIDE,
  //     WsActions.WEAPP_USER_VISIT_IN_POI,
  //     payload => {
  //       if (!payload || !payload.username) return;
  //       return true;
  //     }
  //   );
  //   return () => {
  //     removeWsListener(id1);
  //   };
  // }, [user]);

  return (
    <Modal
      title={
        <>
          <MoneyCollectOutlined /> {title}
        </>
      }
      maskClosable={false}
      width={800}
      open={open}
      destroyOnHidden
      afterClose={() => {
        onClose();
      }}
      onCancel={() => {
        setOpen(false);
      }}
      footer={
        <>
          <PosButton
            onClick={() => {
              setOpen(false);
            }}>
            关闭
          </PosButton>
        </>
      }>
      {order && (
        <div className={styles.container}>
          <Row gutter={10}>
            <Col span={9}>
              <Result
                style={{ paddingTop: 0 }}
                status={'success'}
                title={title}
                // subTitle={
                //   <>
                //     {user && !user.weixinOpenid && (
                //       <div style={{ display: 'inline-block' }}>
                //         <Alert
                //           showIcon
                //           type={'warning'}
                //           message={
                //             '该客户尚未留存，建议推荐客户使用微信扫描小票上的二维码，即可绑定客户关系'
                //           }
                //         />
                //       </div>
                //     )}
                //   </>
                // }
                extra={
                  <Space direction={'horizontal'}>
                    <PosButton
                      autoFocus
                      style={{ width: 120 }}
                      size={'large'}
                      icon={<PoweroffOutlined />}
                      type={'primary'}
                      onClick={() => {
                        // reset();
                        setOpen(false);
                      }}>
                      关闭
                    </PosButton>
                  </Space>
                }
              />
            </Col>
            <Col offset={1} span={14}>
              <UserGuide user={user} order={order} onDataChange={onDataChange} />
            </Col>
          </Row>

          {/* {cardUserList && cardUserList.length && (
            <div style={{ marginBottom: '1em' }}>
              <Typography.Title level={4}>预付卡操作</Typography.Title>
              <Row gutter={[10, 10]}>
                {cardUserList.map(cardUser => {
                  return (
                    <Col span={14} key={cardUser.id}>
                      <CardUserView showAddTime={false} card={cardUser} />
                    </Col>
                  );
                })}
              </Row>
            </div>
          )} */}

          <OrderDescriptions
            postInvalidate={noop}
            orderDetail={{
              order,
              user,
              skuList,
              transactionList: transactionList,
            }}
          />
        </div>
      )}
    </Modal>
  );
};

export default PaymentSuccess;
